var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCibTelegramPlane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0494 5.77782L24.0884 24.4575C23.7894 25.7756 23.0103 26.1038 21.9031 25.4831L15.8675 21.0356L12.9556 23.8369C12.6331 24.1594 12.3641 24.4284 11.7425 24.4284L12.1766 18.2822L23.3619 8.175C23.8484 7.74188 23.2559 7.50094 22.6062 7.935L8.77811 16.6425L2.82499 14.7788C1.5303 14.3747 1.50686 13.4841 3.09499 12.8625L26.3797 3.89157C27.4578 3.4875 28.4009 4.13157 28.0494 5.77875V5.77782Z",
    fill: "#142C53"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCibTelegramPlane);
export default __webpack_public_path__ + "static/media/cib_telegram-plane.1c567a9341dbaeb02d50d291c8440e62.svg";
export { ForwardRef as ReactComponent };